module.exports = __webpack_public_path__ + "static/media/achievement-tracking-hero.5a0e1c79.svg";